import { motion } from "framer-motion";
import { UserPlus, CalendarCheck, HeartHandshake } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SectionTracker } from "./SectionTracker";

const HowItWorks = () => {
  const { t } = useLanguage();

  const steps = [
    { icon: UserPlus, step: "01", titleKey: "how_step1_title", descKey: "how_step1_desc" },
    { icon: CalendarCheck, step: "02", titleKey: "how_step2_title", descKey: "how_step2_desc" },
    { icon: HeartHandshake, step: "03", titleKey: "how_step3_title", descKey: "how_step3_desc" },
  ];

  return (
    <SectionTracker id="how-it-works">
    <section id="how-it-works" className="py-20 md:py-28">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">{t("how_label")}</span>
          <h2 className="font-display text-3xl md:text-4xl text-foreground mt-3 mb-4">
            {t("how_title")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t("how_subtitle")}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((item, i) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="text-center relative"
            >
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-px border-t-2 border-dashed border-border" />
              )}
              <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6 relative">
                <item.icon className="w-10 h-10 text-primary" />
                <span className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-accent text-accent-foreground text-sm font-bold flex items-center justify-center">
                  {item.step}
                </span>
              </div>
              <h3 className="font-display text-xl text-foreground mb-3">{t(item.titleKey)}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed max-w-xs mx-auto">{t(item.descKey)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
    </SectionTracker>
  );
};

export default HowItWorks;
